import React from "react";
import "./TestResult.scss";
import { Button, Modal } from "antd-mobile";
import successSVG from "./svg/result-test-sucess.svg";
import failureSVG from "./svg/result-test-failure.svg";
import withAuth from "../../HOCs/withAuth";

class TestResult extends React.Component {
  state = {
    visible: false
  };
  componentDidMount() {
    if (!this.props.location.state) {
      this.setState({ visible: true });
    }
  }

  render() {
    const { state } = this.props.location;
    if (!state) {
      return null;
    }
    const { isPass, score, isSubmitPersoninfo } = state;
    return (
      <div className="test_result">
        {this.props.location.state && (
          <div className="result_and_score">
            <div className="result_icon">
              <img
                src={isPass === "未通过" ? failureSVG : successSVG}
                alt="考试结果"
              />
            </div>
            <div className="result">
              {isPass === "未通过" ? "考试未通过" : "考试通过"}
            </div>
            <div className="score">您的得分为{score}分</div>
            {!isSubmitPersoninfo && isPass !== "未通过" && (
              <div
                style={{
                  color: "#F5222D",
                  fontSize: 18,
                  textAlign: "center",
                  marginTop: 24,
                  lineHeight: 1.4
                }}
              >
                您的个人信息还未完善 <br />
                无法参加面试
              </div>
            )}
            {isSubmitPersoninfo && isPass !== "未通过" && (
              <div
                style={{
                  color: "#1890FF",
                  fontSize: 18,
                  textAlign: "center",
                  marginTop: 24,
                  lineHeight: 1.4
                }}
              >
                您已通过考试，
                <br />
                请保持联系方式通畅，等待面试通知
              </div>
            )}
          </div>
        )}
        <div className="action_btns">
          {!isSubmitPersoninfo && (
            <Button
              type="primary"
              onClick={() => {
                this.props.history.push("/editinfo");
              }}
              style={{ marginBottom: "1rem" }}
            >
              填写个人详细信息
            </Button>
          )}
          <Button
            onClick={() => {
              this.props.history.push("/home");
            }}
          >
            返回主页
          </Button>
        </div>
        <Modal
          visible={this.state.visible}
          title="提示"
          transparent
          maskClosable={false}
          footer={[
            {
              text: "知道了",
              onPress: () => {
                this.setState({ visible: false });
                this.props.history.push("/interviews");
              }
            }
          ]}
        >
          考试已结束,请前往面试详情查看结果
        </Modal>
      </div>
    );
  }
}

export default withAuth(TestResult);
